/* @flow */

import * as React from 'react';

import {colors, type ColorName} from 'shells/colors';

import './tokenized-item-wrapper.module.css';

type Props = {
    children: ?React.Node,
    colorName?: ColorName,
};

export function TokenizedItemWrapper(props: Props) {
    return (
        <div styleName='tokenized-wrapper'>
            <span
                styleName='tokenized-content'
                style={props.colorName && {backgroundColor: colors[props.colorName]}}
            >
                {props.children}
            </span>
        </div>
    );
}
